import React from "react";
import "../../Style/Header.css";
import { ImageUrl } from "../../constants/url/ImagePath";
import Navbar from "../Shared/Navbar";
import HeaderContent from "./HeaderContent";
import { NavLink } from "react-router-dom";
import { HomeUrl } from "../../constants/url/HomePageUrl";
import { useState } from "react";
import HiringModal from "../Career/Notification/HiringModal";
function Header() {
    const [show, setShow] = useState(true);
  
  return (
    <div className=""> 
            <HiringModal show={show} setShow={setShow} />
      <div className="headerDiv ">
        <Navbar />

        <div className="flex flex-row pt-20">
          <div className="w-1/5 hidden md:flex">
            <img
              src={ImageUrl.waveImage}
              alt=""
              className="w-full float-left mt-5 "
            />
          </div>
          <div className="w-full md:w-3/5 font-semibold not-italic mainHeading ">
            <div className="text-center text-xs-1 sm:text-lg-1 md:text-md-1 lg:text-lg-1 xl:text-xl-1 2xl:text-6xl-1 headingTxt">
              SPRING-INX{" "}
              <span className="textChange headingTxt"> Models and Data</span>
              &nbsp;
              <span className="textChange headingTxt"> </span>
            </div>

            <div className="text-center text-xs-1 sm:text-lg-1 md:text-md-1 lg:text-lg-1 xl:text-xl-1 2xl:text-6xl-1 md:mt-2 headingTxt">
              {" "}
              for
              <span>
                {" "}
                Indian <span className="textChange headingTxt">Languages</span>
              </span>
            </div>
          </div>
          <div className="w-1/5 hidden md:flex">
            <img
              src={ImageUrl.waveImage}
              alt=""
              className="w-full float-right mt-5"
            />
          </div>
        </div>
        <div className="pt-4 md:pt-6 relative">
          <div className="flex flex-wrap justify-center mx-auto">
            <div className="w-full  px-2 md:px-0">
              <p className=" hidden md:block text-center px-52 text-sm-headSmallText sm:text-md-head_des md:text-md-head_des 2xl:lg-recent_head xl:text-xl-head_des 2xl:text-2xl-head_des 3xl:text-3xl font-light  descriptionText ">
                SPRING Lab of IIT Madras is leading a Speech R&D consortium of
                23 institutions as part of the Bhashini (NLTM)
                <NavLink
                  to={HomeUrl.consortium}
                  target="_blank"
                  className="text-blue-500"
                >
                  &nbsp;project.
                </NavLink>{" "}
                {/* <NavLink
                  to={HomeUrl.data2vec_aqc}
                  target="_blank"
                  className="text-blue-500"
                >
                  data2vec-aqc.
                </NavLink> */}
              </p>
            </div>
          </div>
          {/* <div
  onClick={() => setShow(true)}
  title="Careers"
  className="absolute left-1/2 -translate-x-1/2 bottom-4 md:bottom-auto md:left-auto md:translate-x-0 md:right-24 text-white cursor-pointer"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
    />
  </svg>
</div> */}

          <div>
            <HeaderContent />
          </div>

          {/* <div className="relative bottom-10 lg:bottom-32 overflow-hidden whitespace-nowrap w-full">
            <div className="inline-block animate-marquee">
              <p className="font-medium text-[#CE5347] flex gap-x-2 text-sm sm:text-base md:text-[18px] lg:text-xl xl:text-2xl">
                We are excited to announce the release of a second set of new
                data, now available in 8 languages with a total of 1300
                additional hours of content! Explore the latest data
                <NavLink
                  className="text-white underline"
                  to={`${HomeUrl.dataset}`}
                >
                  here
                </NavLink>
              </p>
            </div>
          </div> */}

          <div className="relative bottom-10 lg:bottom-32 overflow-hidden w-full flex flex-col justify-center px-2">
            <div className="inline-block animate-marquee">
              <p className="font-medium text-center lg:whitespace-nowrap text-[#CE5347] gap-x-2 text-sm sm:text-base md:text-[18px] lg:text-xl xl:text-2xl">
                We are excited to announce the release of a second set of new
                data, now available in 8 languages with a total of 1300
                additional hours of content! Explore the latest data &nbsp;
                <span>
                  <NavLink
                    className="text-white underline"
                    to={`${HomeUrl.dataset}`}
                  >
                    here
                  </NavLink>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
// md:w-1/2
